import { Routes } from '@angular/router';
import { canDeactivateFormFn } from '@core/guards';
import { environmentResolver } from './resolvers/environment.resolver';

export const routes: Routes = [
	{
		path: '',
		data: { breadcrumb: 'ENVIRONMENT_LIST.BREADCRUMBS.MAIN' },
		children: [
			{
				path: '',
				loadComponent: () =>
					import(
						'./components/environment-list/environment-list.component'
					).then((component) => component.EnvironmentListComponent)
			},
			{
				path: ':environmentId',
				canDeactivate: [
					(component, _currentRoute, _currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				data: { breadcrumb: 'ENVIRONMENT_EDITION.BREADCRUMBS.MAIN' },
				resolve: { value: environmentResolver },
				loadComponent: () =>
					import(
						'./components/environment-edition/environment-edition.component'
					).then((component) => component.EnvironmentEditionComponent)
			}
		]
	}
];
